export const searchweb = (props) => {
  return {
    type: "websearch",
    payload: props,
  };
};
